import { Typography } from "@maxhub/max-ui"

export const TypographyTitleExample = {
    title: 'Typography.Title',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Hello world',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
        {
            name: 'variant',
            label: 'variant',
            type: 'enum',
            tsType: ['"small"', '"custom"', '"large-strong"', '"medium"', '"medium-strong"', '"small-strong"'],
            default: 'large-strong',
            options: ['small', 'custom', 'large-strong', 'medium', 'medium-strong', 'small-strong'],
        },
    ],

    Preview({ props }){
        const titleProps = {
            ...(props.variant ? { variant: props.variant } : {}),
        }

        return (
            <Typography.Title {...titleProps}>
                {props.children}
            </Typography.Title>
        )
    },

    getCode(props){
        return `<Typography.Title${props.variant !== 'large-strong' ? `\n  variant="${props.variant}"` : ''}>
  ${props.children}
</Typography.Title>`
    }

}